import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import Box from '@mui/material/Box'

// ** Icon Imports
import Icon from 'src/@core/components/icon'

// ** Custom Components Import
import MessagesLog from './whatapp-log'
import Image from 'next/image'

// ** Styled Components
const ChatWrapperStartChat = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  height: '100%',
  display: 'flex',
  borderRadius: 1,
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  backgroundColor: theme.palette.action.hover
}))

const TextMessagesContent = props => {
  // ** Props
  const { data, store, hidden, mdAbove, handleLeftSidebarToggle, handleUserProfileRightSidebarToggle, headImg } = props

  const handleStartConversation = () => {
    if (!mdAbove) {
      handleLeftSidebarToggle()
    }
  }

  const renderContent = () => {
    if (store) {
      const selectedMessage = store.selectedMessage

      if (!selectedMessage) {
        return (
          <ChatWrapperStartChat
            sx={{
              ...(mdAbove ? { borderTopLeftRadius: 0, borderBottomLeftRadius: 0 } : {})
            }}
          >
            <Box
              onClick={handleStartConversation}
              sx={{
                px: 6,
                py: 2.25,
                boxShadow: 3,
                borderRadius: 5,
                backgroundColor: 'background.paper',
                cursor: mdAbove ? 'default' : 'pointer'
              }}
            >
              <Typography sx={{ fontWeight: 600 }}>Start Conversation</Typography>
            </Box>
          </ChatWrapperStartChat>
        )
      } else {
        return (
          <Box
            sx={{
              flexGrow: 1,
              width: '100%',
              height: '100%',
              backgroundColor: '#F9FAFB'
            }}
          >
            <Box
              sx={{
                py: 3,
                px: 5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                borderBottom: theme => `1px solid ${theme.palette.divider}`,
                backgroundColor: '#EFEFEF',
                height: '60px'
              }}
              className='border-b-[1px] border-l-[1px] border-black border-opacity-10'
            >
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {mdAbove ? null : (
                  <IconButton onClick={handleLeftSidebarToggle} sx={{ mr: 2 }}>
                    <Icon icon='mdi:menu' />
                  </IconButton>
                )}
                <Box
                  onClick={handleUserProfileRightSidebarToggle}
                  sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                >
                  <div sx={{ display: 'flex', flexDirection: 'column' }} className='flex items-center '>
                    <div className=''>
                      {/* <Image src={headImg} alt='' width={32} height={32} className=' rounded-full' /> */}
                    </div>
                    <div className='ml-2 font-bold text-[15px]'>
                      <h2>
                        {' '}
                        {JSON.stringify(selectedMessage.contact) !== '{}' ? selectedMessage.contact.subject : ''}
                      </h2>
                      {/* <p className='text-[12px] font-normal'>{selectedMessage.chat.contact.label}</p> */}
                    </div>
                  </div>
                </Box>
              </Box>
              <div className=''>
                <Icon icon='logos:whatsapp-icon' className='w-[40px] h-[40px]' />
              </div>
            </Box>

            {selectedMessage ? <MessagesLog hidden={hidden} data={{ ...selectedMessage }} /> : null}
          </Box>
        )
      }
    } else {
      return null
    }
  }

  return renderContent()
}

export default TextMessagesContent
